import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Patent')

export default {
  label: 'Patent',
  route: 'patent',
  className: 'patent',
  fields: [
    ListFields.SortableField('titel', true),
    ListFields.UnsortableReference('haupterfinder', true),
    ListFields.SortableField('veroeffentlichungsnummer', true),
    ListFields.SortableDate('datumDerPrioritaetsbegruendendenErstanmeldung', true),
    ListFields.SortableField('lizenzen', false),
    ListFields.SortableField('forschungsgebiet', false),
    ListFields.UnsortableReference('anmelderExtern', false),
    ListFields.UnsortableReference('anmelderIntern', false),
    ListFields.UnsortableReference('ansprechpartner', false),
    ListFields.UnsortableReference('land', true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Patent.js